import { useQuery } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { AxiosError } from 'axios';
import { useSchoolSchoolyear } from 'containers/App/context/SchoolyearSchoolProvider';

function getNextActions({
  schoolyearId,
  schoolId,
  livretEleveId,
  remark,
}: {
  schoolyearId: string;
  schoolId: string;
  livretEleveId: string;
  remark: string;
}) {
  const requestURL = `/schoolyears/${schoolyearId}/schools/${schoolId}/livrets-eleves/${livretEleveId}/next-actions-prompt`;
  return request(requestURL, {
    method: 'POST',
    body: {
      remark,
    },
  }).then(res => res?.data || []);
}

export interface NextAction {
  label: string;
  description: string;
  prompt: string;
}

export function useNextActions({
  livretEleveId,
  enabled,
  remark,
}: {
  livretEleveId: string;
  enabled: boolean;
  remark: string;
}) {
  const { schoolyear, school } = useSchoolSchoolyear();
  const queryResult = useQuery<NextAction[], AxiosError, NextAction[]>({
    queryKey: ['NEXT_ACTIONS_KEY', livretEleveId, remark],
    queryFn: () =>
      getNextActions({
        schoolyearId: schoolyear.id,
        schoolId: school.id,
        livretEleveId,
        remark,
      }),
    enabled,
  });

  return queryResult;
}
